/**
 * ProgressIndicator — gradient bar + stage label + step dots.
 * Reads `progress_percent` directly from backend StageResponse.
 * Never reveals scores or per-door confidence.
 */
const STAGE_LABELS = {
  core: "Reflect for a moment",
  tiebreaker: "A few more reflections",
  pathway: "Going a little deeper",
  profile: "Who you are right now",
  complete: "Your reflection",
};

const STAGE_ORDER = ["core", "pathway", "profile", "complete"];

export default function ProgressIndicator({ stage, progressPercent }) {
  const label = STAGE_LABELS[stage] || "Reflecting…";
  const currentIndex = STAGE_ORDER.indexOf(stage === "tiebreaker" ? "core" : stage);

  return (
    <div className="space-y-3" data-testid="kcis-progress">
      <div className="flex items-center justify-between">
        <span className="kcis-assessment-overline" data-testid="kcis-progress-stage-label">
          {label}
        </span>
        <span className="text-xs text-slate-500" data-testid="kcis-progress-percent">
          {progressPercent}%
        </span>
      </div>
      <div className="kcis-progress-track" aria-hidden>
        <div
          className="kcis-progress-fill"
          style={{ width: `${Math.max(0, Math.min(100, progressPercent || 0))}%` }}
        />
      </div>
      <div className="flex items-center gap-2 pt-1" aria-hidden>
        {STAGE_ORDER.slice(0, -1).map((s, idx) => {
          const done = idx < currentIndex;
          const active = idx === currentIndex;
          return (
            <span
              key={s}
              className={`kcis-step-dot ${
                active ? "kcis-step-dot--active" : done ? "kcis-step-dot--done" : ""
              }`}
              data-testid={`kcis-step-${s}`}
            />
          );
        })}
      </div>
    </div>
  );
}
